module.exports = __webpack_public_path__ + "static/media/plus.eaaebeab.svg";